export const defaultLoadingClass = 'lazy-image--loading';
